<template>
  <ContentWrap>
    <el-alert
      v-if="erpDisabled"
      type="warning"
      :closable="false"
      show-icon
      title="律所 ERP 未开启"
      description="请平台在租户配置 features_json 中设置 firmErpEnabled=true。"
      class="mb-12px"
    />
    <el-row v-else :gutter="16" class="mb-16px">
      <el-col :xs="12" :sm="8" :md="6">
        <el-card shadow="hover" class="stat" @click="goHearing">
          <div class="label">今日开庭</div>
          <div class="num">{{ summary?.todayHearingCount ?? '—' }}</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="8" :md="6">
        <el-card shadow="hover" class="stat" @click="goDeadline">
          <div class="label">即将到期</div>
          <div class="num">{{ summary?.upcomingDeadlineCount ?? '—' }}</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="8" :md="6">
        <el-card shadow="hover" class="stat" @click="goTask">
          <div class="label">逾期任务</div>
          <div class="num">{{ summary?.overdueTaskCount ?? '—' }}</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="8" :md="6">
        <el-card shadow="hover" class="stat" @click="goTime">
          <div class="label">待审工时</div>
          <div class="num">{{ summary?.pendingTimeEntryCount ?? '—' }}</div>
        </el-card>
      </el-col>
    </el-row>
    <div v-if="!erpDisabled" class="actions">
      <el-button type="primary" @click="goMatter">案件工作台</el-button>
      <el-button @click="goCustomer">客户</el-button>
      <el-button @click="goHearing">开庭</el-button>
      <el-button @click="goTask">任务</el-button>
      <el-button @click="goDeadline">期限</el-button>
      <el-button @click="goAlert">预警</el-button>
      <el-button @click="goTime">工时</el-button>
      <el-button @click="goDossier">卷宗</el-button>
      <el-button @click="goFee">收费</el-button>
      <el-button :loading="loading" @click="load">刷新</el-button>
    </div>
  </ContentWrap>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { FirmPracticeApi, type PracticeDashboardVO } from '@/api/firm/practice'
import { firmPath } from '@/views/firm-portal/registry/paths'

defineOptions({ name: 'FirmPracticeDashboard' })

const router = useRouter()
const loading = ref(false)
const erpDisabled = ref(false)
const summary = ref<PracticeDashboardVO | null>(null)

const load = async () => {
  loading.value = true
  erpDisabled.value = false
  try {
    summary.value = await FirmPracticeApi.dashboardSummary()
  } catch (e: any) {
    const msg = String(e?.message || e?.msg || '')
    if (msg.includes('ERP') || msg.includes('firmErpEnabled')) {
      erpDisabled.value = true
    }
  } finally {
    loading.value = false
  }
}

const goMatter = () => router.push(firmPath('/practice/matter'))
const goCustomer = () => router.push(firmPath('/practice/customer'))
const goTime = () => router.push(firmPath('/practice/time'))
const goDossier = () => router.push(firmPath('/practice/dossier'))
const goFee = () => router.push(firmPath('/practice/fee'))
const goHearing = () => router.push(firmPath('/practice/hearing'))
const goTask = () => router.push(firmPath('/practice/task'))
const goDeadline = () => router.push(firmPath('/practice/deadline'))
const goAlert = () => router.push(firmPath('/practice/alert'))

onMounted(load)
</script>

<style scoped>
.stat {
  cursor: pointer;
  margin-bottom: 12px;
}
.label {
  font-size: 13px;
  color: #64748b;
}
.num {
  margin-top: 6px;
  font-size: 26px;
  font-weight: 600;
  color: #1e3a3a;
}
.actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
</style>
